window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
  init: function () {
    this.Basic.init();
  },
  Basic: {
    init: function () {
      this.smoothScroll();
      this.marqueeScroller();
      this.slideshowSwiper();
      this.collapsibleContent();
      // this.sticky_header();
      this.video_media();
    },
    video_media: function(){
      class THMLazyLoadingVideo extends HTMLElement {
        constructor() {
          super(),
            (this.iframe = this.querySelector("iframe")),
            (this.template = this.querySelector("template")),
            (this.isMouseenter = !1);
        }
        loadVideo() {
          var t;
          this.iframe &&
            (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
            this.iframe.addEventListener(
              "load",
              function () {
                "youtube" == this.dataVideoType &&
                  this.iframe.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  ),
                  "vimeo" == this.dataVideoType &&
                    this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
              }.bind(this)
            )),
            "local_video" == this.dataVideoType &&
              ((this.local_video = this.querySelector("video")),
              (t = this.local_video.querySelector("source").getAttribute("data-src")),
              (this.local_video.src = t));
        }
        execute() {
          Shopify.designMode
            ? this.loadVideo()
            : (["mousemove", "touchstart"].forEach(
                function (t) {
                  THMHelper.qs("body").addEventListener(
                    t,
                    function (t) {
                      this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                    }.bind(this),
                    { once: !0 }
                  );
                }.bind(this)
              ),
              window.addEventListener(
                "scroll",
                function (t) {
                  this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                }.bind(this),
                { once: !0 }
              ));
        }
        static get observedAttributes() {
          return ["data-video-type", "data-video-id"];
        }
        set dataVideoType(t) {
          this.setAttribute("data-video-type", t);
        }
        get dataVideoType() {
          return this.getAttribute("data-video-type");
        }
        set dataVideoId(t) {
          this.setAttribute("data-video-id", t);
        }
        get dataVideoId() {
          return this.getAttribute("data-video-id");
        }
        attributeChangedCallback(t, e, s) {
          e !== s && this.execute();
        }
        connectedCallback() {
          this.execute();
        }
        disconnectedCallback() {}
      }
      customElements.define("thm-load-video", THMLazyLoadingVideo);

      class THMLoadMedia extends HTMLElement {
        constructor() {
          super(),
            (this.$ = this.querySelector.bind(this)),
            (this.sectionID = this.dataset.sectionId),
            (this.idVideo = this.dataset.idVideo),
            (this.typeVideo = this.dataset.type),
            (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
            (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
            (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
            (this.trigger = this.$(".js-load-media-trigger")),
            this.trigger &&
              this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
        }
        handlePlayVideo() {
          this.classList.add("playing");
          this.loadContent();
          const t = this.querySelector(".js-media-item-video");
          t &&
            t.addEventListener("play", () => {
              this.pauseAllVideo(t), t.play();
            });
        }
        onYouTubeIframeAPIReady() {
          if ("undefined" != typeof YT && void 0 !== YT.Player)
            try {
              this.player = new YT.Player(this.eleVideo, {
                videoId: this.idVideo,
                playerVars: { playsinline: 1 },
                events: {
                  onReady: this.onPlayerYTReady,
                  onStateChange: this.onPlayerStateYTChange,
                },
              });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát YouTube:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://www.youtube.com/iframe_api"),
                (t.onload = () => {
                  this.onYouTubeIframeAPIReady();
                }),
                document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onVimeoIframeAPIReady() {
          if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
            try {
              var t = { id: this.idVideo, autoplay: 1 };
              (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                this.playerVimeo.on("play", () => {
                  this.pauseAllVideo(this.playerVimeo);
                });
            } catch (t) {
              console.error("Lỗi khi tạo trình phát Vimeo:", t);
            }
          else {
            var t = document.createElement("script"),
              e =
                ((t.src = "https://player.vimeo.com/api/player.js"),
                (t.onload = () => {
                  this.onVimeoIframeAPIReady();
                }),
                document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
          }
        }
        onPlayerYTReady = () => {
          this.pauseAllVideo(this.player), this.player.playVideo();
        };
        onPlayerStateYTChange = (t) => {
          1 == t.data && this.onPlayerPlay();
        };
        onPlayerPlay = () => {
          this.pauseAllVideo(this.player);
        };
        loadContent() {
          if (!this.getAttribute("loaded")) {
            if (this.$("template")) {
              var t = this.$("template").content.firstElementChild.cloneNode(!0);
              this.appendChild(t),
                this.isLoaded(!0),
                this.trigger && this.trigger.remove();
            } else {
              if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
              else {
                if ("vimeo" != this.typeVideo) return !0;
                this.onVimeoIframeAPIReady();
              }
              this.trigger?.classList.add("d-none"),
                this.$(".js-media-item").classList.add("d-flex");
            }
            return !0;
          }
        }
        pauseAllVideo(e) {
          THMHelper.qsa(
            ".js-product-media-deferred-video:has([data-type='youtube']"
          ).forEach((t) => {
            t.player && e !== t.player && t.player?.pauseVideo();
          }),
          THMHelper.qsa(
              ".js-product-media-deferred-video:has([data-type='vimeo'])"
            ).forEach((t) => {
              t.playerVimeo !== e && t.playerVimeo?.pause();
            }),
            THMHelper.qsa(".js-media-item-video").forEach((t) => {
              t !== e && t.pause();
            });
        }
        isLoaded(t) {
          t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
        }
      }
      customElements.define("thm-load-media", THMLoadMedia);
    },
    sticky_header: function () {
      var header = document.querySelector('[data-sticky-type="always"]');

      if(header != null){
        onScroll = () => {
          var scrolledPage = Math.round(window.pageYOffset);
          if (scrolledPage > 80) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }
        }
        document.addEventListener('scroll', onScroll);
      }

    },
    smoothScroll: function () {
      document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#recover"]):not([href="#login"])').forEach(a => {
        a.addEventListener('click', function (e) {
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
            if (target) {
              e.preventDefault();
              window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
              setTimeout(() => {
                target.focus();
                if (!target.matches(':focus')) {
                  target.setAttribute('tabindex', '-1');
                  target.focus();
                }
              }, 600);
            }
          }
        });
      });

    },
    marqueeScroller: function () {
      if (!customElements.get("marquee-content")) {
        class Marquee extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          calculationPaddingSection() {
            (this.heightSection = this.offsetHeight),
              (this.heightSection =
                this.heightSection < 18
                  ? 18
                  : 96 < this.heightSection
                    ? 96
                    : this.heightSection),
              this.closest(".js-running-content").style.setProperty(
                "--spacing-padding-block",
                this.heightSection + "px"
              );
          }
          init() {
            (this.distance =
              this.querySelector(".js-marquee-item").offsetWidth),
              (this.speed = this.dataset.speed),
              this.style.setProperty(
                "--marquee-duration",
                this.distance / this.speed + "s"
              );
          }
        }
        customElements.define("marquee-content", Marquee);
      }
    },
    slideshowSwiper: function () {

      class slideshowSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");

          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
              : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
              let nextButton = this.querySelectorAll(".swiper-button-next-custom");
              let prevButton = this.querySelectorAll(".swiper-button-prev-custom");

              let next = this.querySelector(".swiper-button-next");
              let prev = this.querySelector(".swiper-button-prev");

          let pagination = this.querySelector(".swiper-pagination");
          let scroll = this.querySelector(".swiper-scrollbar");

          const swiper =  new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: false,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay),
            },
    
            pagination: {
              el: pagination,
              clickable: true,
            },
            scrollbar: {
              el: scroll,
              draggable: true,
            },
            breakpoints: {
              359: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              700: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            }
          });
                        // Manually bind all next/prev buttons to swiper
              nextButton.forEach((btn) => {
                btn.addEventListener("click", () => swiper.slideNext());
              });

              prevButton.forEach((btn) => {
                btn.addEventListener("click", () => swiper.slidePrev());
              });

                 // Disable/hide custom buttons at edges when loop is false
    const updateCustomNavState = () => {
      if (!swiper.params.loop) {
        nextButton.forEach((btn) => {
          btn.disabled = swiper.isEnd;
          btn.classList.toggle("swiper-button-disabled", swiper.isEnd);
          // btn.style.display = swiper.isEnd ? "none" : ""; // Uncomment to HIDE instead of disable
        });
        prevButton.forEach((btn) => {
          btn.disabled = swiper.isBeginning;
          btn.classList.toggle("swiper-button-disabled", swiper.isBeginning);
          // btn.style.display = swiper.isBeginning ? "none" : ""; // Uncomment to HIDE instead of disable
        });
      }
    };

    swiper.on("init", updateCustomNavState);
    swiper.on("slideChange", updateCustomNavState);
    updateCustomNavState(); // Initial call


        }
      }
      customElements.define("slideshow-swiper", slideshowSwiper);



      

    },

    collapsibleContent: function () {

        if (!customElements.get("collapsible-content")) {
                class collapsibleContent extends HTMLElement {
                    constructor() {
                        super();
                        this.disclosure = this.querySelector('details');
                        this.toggle = this.querySelector('summary');
                        this.panel = this.toggle.nextElementSibling;
                        this.init();
                    }

                    init() {
                        // Check if the content element has a CSS transition.
                        if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
                            this.toggle.addEventListener('click', this.handleToggle.bind(this));
                            this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
                        }
                    }

                    /**
                     * Handles 'click' events on the summary element.
                     * @param {object} evt - Event object.
                     */
                    handleToggle(evt) {
                        evt.preventDefault();

                        if (!this.disclosure.open) {
                            this.open();
                        } else {
                            this.close();
                        }
                    }

                    /**
                     * Handles 'transitionend' events on the details element.
                     * @param {object} evt - Event object.
                     */
                    handleTransitionEnd(evt) {
                        if (evt.target !== this.panel) return;

                        if (this.disclosure.classList.contains('is-closing')) {
                            this.disclosure.classList.remove('is-closing');
                            this.disclosure.open = false;
                        }

                        this.panel.removeAttribute('style');
                    }

                    /**
                     * Adds inline 'height' style to the content element, to trigger open transition.
                     */
                    addContentHeight() {
                        this.panel.style.height = `${this.panel.scrollHeight}px`;
                    }

                    /**
                     * Opens the details element.
                     */
                    open() {
                        // Set content 'height' to zero before opening the details element.
                        this.panel.style.height = '0';

                        // Open the details element
                        this.disclosure.open = true;

                        // Set content 'height' to its scroll height, to enable CSS transition.
                        this.addContentHeight();
                    }

                    /**
                     * Closes the details element.
                     */
                    close() {
                        // Set content height to its scroll height, to enable transition to zero.
                        this.addContentHeight();

                        // Add class to enable styling of content or toggle icon before or during close transition.
                        this.disclosure.classList.add('is-closing');

                        // Set content height to zero to trigger the transition.
                        // Slight delay required to allow scroll height to be applied before changing to '0'.
                        setTimeout(() => {
                            this.panel.style.height = '0';
                        });
                    }
                }
                customElements.define('collapsible-content', collapsibleContent);
            }

    
    }
  },
};


document.addEventListener('DOMContentLoaded', function () {
  Thm.init();
});



class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.option = this.querySelector(".color-swatch__radio");
    this.variantId = this.option.dataset.variantId;
    this.productHandle = this.option.dataset.productHandle;
    this.productCard = this.option.closest(".product-card-wrapper");
    this.form = this.productCard.querySelector(".form");
    this.option.addEventListener("change", this.onSwatchChange.bind(this));

  // if (this.option.checked) {
  //   this.onSwatchChange();
  // }


  }

  onSwatchChange() {
    let url = `${window.shopUrl}/products/${this.productHandle}?variant=${this.variantId}&view=colorswatch`;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        if( this.form != null){
          this.form.querySelector('input[name="id"]').value = this.variantId;
        }
   
        this.updatePrice(html);
        this.updateThumbnail(html);
        this.cardBadge(html);
        this.cartButton(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateThumbnail(html) {

    const media = this.productCard.querySelector(".media");

    if(media != null){
      const destination = media.querySelector("img:first-child");


    const source = html.querySelector(".product__media-item.is-active").querySelector(".product__media img");
    if (source && destination) {
      destination.src = source.src;
      destination.srcset = source.srcset;
    }
    }


  }

  updatePrice(html) {
    const destination = this.productCard.querySelector(".price__container");
    const source = html.querySelector(".price__container");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }
  cardBadge(html) {
    const destination = this.productCard.querySelector(".card__badge");
    const source = html.querySelector(".card__badge");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  cartButton(html) {
    const destination = this.productCard.querySelector(".quick-add__submit");
    const source = html.querySelector(".quick-add__submit");
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    destination.removeAttribute("aria-disabled");
    }

  }
}
customElements.define("color-swatch", ColorSwatch);




      class AutoSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.sliderWrapper = this.querySelector(".slideshow__swiper");
          if (!this.sliderWrapper) return;
          const resizeObserver = new ResizeObserver((entries) => this.init());
          resizeObserver.observe(this.sliderWrapper);
          //  console.log("testdd",this.sliderWrapper.dataset)
        }
        init() {
          let centered_slides =
            this.sliderWrapper.dataset.centeredslides !== undefined ? JSON.parse(this.sliderWrapper.dataset.centeredslides) : undefined;
          let effect_fade =
            this.sliderWrapper.dataset.effectfade !== undefined
              ? JSON.parse(this.sliderWrapper.dataset.effectfade)
              : undefined;
          let next = this.querySelector(".swiper-button-next");
          let prev = this.querySelector(".swiper-button-prev");
          let pagination = this.querySelector(".swiper-pagination");

          // console.log("Tress", centered_slides);

          const slider = new Swiper(this.sliderWrapper, {
            effect: effect_fade ? "fade" : "slide",
            centeredSlides: centered_slides ? centered_slides : false,
            slidesPerView: 'auto',
            spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
            grabCursor: true,
            horizontal: true,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
            loop: JSON.parse(this.sliderWrapper.dataset.loop),
            speed: 700,
            mousewheel: {
              forceToAxis: true,
            },
            autoplay: {
              enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
              disableOnInteraction: false,
              delay: parseInt(this.sliderWrapper.dataset.delay)
            },
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            breakpoints: {
              359: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
              },
              720: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
              },
              1024: {
                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
              },
            },
          });

          return slider;
        }
      }
      customElements.define("auto-swiper", AutoSwiper);



document.querySelectorAll(".toggle-button").forEach((button) => {
  button.addEventListener("click", () => {
    const targetId = button.getAttribute("data-target");
    const targetContent = document.querySelector(targetId);

    // Slide up all contents
    document.querySelectorAll(".radio-content").forEach((content) => {
      content.classList.remove("active");
      content.style.maxHeight = 0;
    });

    // Slide down target content
    targetContent.classList.add("active");
    targetContent.style.maxHeight = targetContent.scrollHeight + "px";
  });
});



const btn = document.getElementById('copybtn');

if (btn) { // null check 
  btn.addEventListener('click', function() {
    const code = btn.getAttribute('data-code');
    if (code) { // null check for data-code
      navigator.clipboard.writeText(code).then(() => {
        // Optional: change button text temporarily
        const originalText = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(() => btn.textContent = originalText, 1500);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    } else {
      console.warn('No data-code found on button.');
    }
  });
}


    if (!customElements.get('tabbed-content')) {
        class Tabs extends HTMLElement {
          constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
            this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
            this.tabs = this.querySelectorAll('[role="tab"]');
            this.panels = this.querySelectorAll('[role="tabpanel"]');
      
            // If no tab is active by default, activate the first tab.
            if (!this.activeTab) {
              this.activeTab = this.tabs[0];
              this.activateTab(this.activeTab);
            }
      
            this.addListeners();
          }
      
          addListeners() {
            this.tabList.addEventListener('click', this.handleClick.bind(this));
            this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
          }
      
          handleClick(evt) {
            if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
            this.activateTab(evt.target);
      
          }
      
          handleKeydown(evt) {
            switch (evt.key) {
              case 'ArrowLeft':
              case 'ArrowRight':
                evt.preventDefault();
                if (!this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'ArrowUp':
              case 'ArrowDown':
                evt.preventDefault();
                if (this.isVerticalTablist) {
                  this.switchTabOnKeyPress(evt.key);
                }
                break;
      
              case 'Home':
                evt.preventDefault();
                this.activateTab(this.tabs[0]);
                break;
      
              case 'End':
                evt.preventDefault();
                this.activateTab(this.tabs[this.tabs.length - 1]);
                break;
            }
          }
      
          switchTabOnKeyPress(key) {
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                this.activateTab(this.tabs[0]);
              } else {
                this.activateTab(this.activeTab.nextElementSibling);
              }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              if (this.activeTab === this.tabs[0]) {
                this.activateTab(this.tabs[this.tabs.length - 1]);
              } else {
                this.activateTab(this.activeTab.previousElementSibling);
              }
            }
          }
      
          activateTab(tab) {
            this.deactivateActiveTab();
      
            Tabs.setTabState(tab, true);
            tab.removeAttribute('tabindex');
            this.activeTab = tab;
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              panel.classList.add('fade-in');  // Add animation class
      
              setTimeout(() => {
                panel.classList.remove('fade-in');
              }, 500);
            }
      
            if (document.activeElement.matches('.tablist__tab')) {
              tab.focus();
            }
          }
      
          deactivateActiveTab() {
            Tabs.setTabState(this.activeTab, false);
            this.activeTab.setAttribute('tabindex', '-1');
            this.activeTab = null;
          }
      
          static setTabState(tab, active) {
            tab.setAttribute('aria-selected', active);
      
            const panelId = tab.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
      
            if (panel) {
              if (active) {
                panel.hidden = false;
              } else {
                panel.hidden = true;
              }
            }
          }
      
        }
      
        customElements.define('tabbed-content', Tabs);
      }